export const createCache = <Key, Value>() => {
  const map = new Map<Key, Value>();
  return {
    use: (key: Key, getter: () => Value): Value => {
      if (map.has(key)) return map.get(key) as Value;
      const value = getter();
      map.set(key, value);
      return value;
    },
  };
};
